import { useVisibilityObserver } from '~/domains/common/hooks/useVisibilityObserver';

import { useSetMarketGroupVisibility } from '../state/marketVisibility.store';

export type ObserveMarketGroupRef = (marketGroupId: string) => (node: Element | null) => void;

export function useMarketGroupVisibility(): ObserveMarketGroupRef {
  const setMarketGroupVisibility = useSetMarketGroupVisibility();

  const { observe } = useVisibilityObserver({ onChange: setMarketGroupVisibility });

  return observe;
}
